export const regimenFiscalData = [
    {clave: 601, regimen: "General de Ley Personas Morales"},
    {clave: 603, regimen: "Personas Morales con Fines no Lucrativos"},
    {clave: 605, regimen: "Sueldos y Salarios e Ingresos Asimilados a Salarios"},
    {clave: 606, regimen: "Arrendamiento"},
    {clave: 607, regimen: "Régimen de Enajenación o Adquisición de Bienes"},
    {clave: 608, regimen: "Demás ingresos"},
    {clave: 610, regimen: "Residentes en el Extranjero sin Establecimiento Permanente en México"},
    {clave: 611, regimen: "Ingresos por Dividendos (socios y accionistas)"},
    {clave: 612, regimen: "Personas Físicas con Actividades Empresariales y Profesionales"},
    {clave: 614, regimen: "Ingresos por intereses"},
    {clave: 615, regimen: "Régimen de los ingresos por obtención de premios"},
    {clave: 616, regimen: "Sin obligaciones fiscales"},
    {clave: 620, regimen: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos"},
    {clave: 621, regimen: "Incorporación Fiscal"},
    {clave: 622, regimen: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"},
    {clave: 623, regimen: "Opcional para Grupos de Sociedades"},
    {clave: 624, regimen: "Coordinados"},
    {clave: 625, regimen: "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas"},
    {clave: 626, regimen: "Régimen Simplificado de Confianza"}
];

export const reginmenFiscalOptions = regimenFiscalData.map((regimen) => (
    {value: regimen.clave, label:`${regimen.clave} - ${regimen.regimen}`}
));

export function getRegimen(claves) {

    const clavesArray = typeof claves === "string"
        ? claves.split(",").map(c => parseInt(c.trim()))
        : [parseInt(claves)];

    const resultados = clavesArray.map((clave) => {
        const found = regimenFiscalData.find((regimen) => regimen.clave === clave);
        return found ? `${found.clave} - ${found.regimen}` : null;
    }).filter(Boolean); // elimina los null

    return resultados.join(", ");
}